import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Box, Menu, MenuItem } from 'components';
import { Link, ExternalLink } from 'core/routing';
import { CommunityIcon, MoreIcon } from 'icons';
import { useClientStore } from 'apps/hooks';
import { handleCommunityClick } from 'apps/routes/utils';
import { themes } from 'styles/themes/wikifactoryNew';
import { FrameSidebarWidth } from 'styles/constants';
import { isInDesktopMode } from 'libs/gutClient/electronBridge';
import * as Icons from './icons';

const FooterMenu = observer(() => {
  const [anchorEl, setAnchor] = useState<null | HTMLElement>(null);
  const clientStore = useClientStore();
  const isOpen = Boolean(anchorEl);
  const desktopMode = isInDesktopMode();
  const shrinkHeightRange = desktopMode ? 570 : 600;
  const shouldFixed = clientStore.windowHeight > shrinkHeightRange;

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isOpen) {
      setAnchor(null);
    } else {
      setAnchor(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchor(null);
  };

  // 3.6 rem * 16 to px value
  const RightGapAndMoreIconWidth = 3.6 * 16;

  return (
    <div>
      <div
        className={`${
          shouldFixed ? 'fixed' : 'sticky mt-2'
        } bottom-2 flex justify-between items-center`}
      >
        <div
          className='flex h-8 rounded items-center mr-3 p-1 hover:bg-gray-50 border-gray-100 cursor-pointer'
          onClick={() => {
            handleCommunityClick();
          }}
          style={{
            width: FrameSidebarWidth - RightGapAndMoreIconWidth,
            border: `1px solid ${themes.color.wfGrey100}`,
          }}
        >
          <CommunityIcon color={themes.color.wfGrey100} />
          <p className='ml-2 text-black text-sm'>Community</p>
        </div>
        <div
          className='w-9 h-8 flex items-center justify-center border-gray-100 cursor-pointer rounded hover:bg-gray-50'
          onClick={handleMoreClick}
          style={{
            border: `1px solid ${themes.color.wfGrey100}`,
          }}
        >
          <MoreIcon />
        </div>
      </div>
      <Menu
        placement='right-bottom'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <Link name='home.company.about'>
          <MenuItem>
            <Box mr={2}>
              <Icons.Information />
            </Box>
            About Wikifactory
          </MenuItem>
        </Link>
        <ExternalLink to='https://help.wikifactory.com/en/'>
          <MenuItem>
            <Box mr={2}>
              <Icons.HelpCenter />
            </Box>
            Help Center
          </MenuItem>
        </ExternalLink>
        <Link name='home.privacy'>
          <MenuItem>
            <Box mr={2}>
              <Icons.PrivatePolicy />
            </Box>
            Privacy Policy
          </MenuItem>
        </Link>
        <Link name='home.cookies'>
          <MenuItem>
            <Box mr={2}>
              <Icons.Cookies />
            </Box>
            Cookies Policy
          </MenuItem>
        </Link>
        <Link name='home.terms'>
          <MenuItem>
            <Box mr={2}>
              <Icons.TermsConditions />
            </Box>
            Terms & Conditions
          </MenuItem>
        </Link>
      </Menu>
    </div>
  );
});

export default FooterMenu;
